/* eslint-disable vue/multi-word-component-names */

import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home.vue'
import GroupView from '../views/Group/index.vue'
import TalentView from '../views/Talent/index.vue'
import TalentPlan from '@/views/Talent/TalentPlan.vue'
Vue.use(VueRouter)

// 重写路由的push方法
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/group',
    name: 'group',
    component: GroupView
  },
  {
    path: '/talent',
    name: 'talent',
    component: TalentView
  },
  {
    path: '/talent/plan',
    name: 'TalentPlan',
    component: TalentPlan,
    meta: {
      title: '人才计划解读'
    }
  },
  {
    path: '/talent/policy',
    name: 'TalentPolicy',
    component: () => import('@/views/Talent/policy.vue')
  },
  {
    path: '/talent/plan/detail/:id',
    name: 'TalentPlanDetail',
    component: () => import('@/views/Talent/TalentPlanDetail.vue')
  },
  {
    path: '/talent/policy/detail/:id',
    name: 'PolicyDetail',
    component: () => import('@/views/Talent/PolicyDetail.vue')
  },
  {
    path: '/talent/recruitment',
    name: 'Recruitment',
    component: () => import('@/views/Talent/recruitment.vue')
  },
  {
    path: '/talent/recruitment/detail/:id',
    name: 'RecruitmentDetail',
    component: () => import('@/views/Talent/recruitmentDetail.vue')
  },
  {
    path: '/talent/recommend',
    name: 'Recommend',
    component: () => import('@/views/Talent/recommend.vue')
  },
  {
    path: '/talent/recommend/detail/:id',
    name: 'RecommendDetail',
    component: () => import('@/views/Talent/recommendDetail.vue')
  },
  {
    path: '/enterprise/lifecycle',
    name: 'EnterpriseLifecycle',
    component: () => import('@/views/Enterprise/lifecycle.vue')
  },
  {
    path: '/enterprise/policy',
    name: 'EnterprisePolicy',
    component: () => import('@/views/Enterprise/policy.vue')
  },
  {
    path: '/enterprise/policy/detail/:id',
    name: 'EnterprisePolicyDetail',
    component: () => import('@/views/Enterprise/PolicyDetail.vue')
  },
  {
    path: '/government/service',
    name: 'GovernmentService',
    component: () => import('@/views/Government/service.vue')
  },
  {
    path: '/government/cooperation',
    name: 'GovernmentCooperation',
    component: () => import('@/views/Government/cooperation.vue')
  },
  {
    path: '/government/cooperation/detail/:id',
    name: 'GovernmentCooperationDetail',
    component: () => import('@/views/Government/cooperationDetail.vue')
  },
  {
    path: '/government/innovation',
    name: 'GovernmentInnovation',
    component: () => import('@/views/Government/innovation.vue')
  },
  {
    path: '/government/innovation/detail/:id',
    name: 'GovernmentInnovationDetail',
    component: () => import('@/views/Government/innovationDetail.vue')
  },
  {
    path: '/activity',
    name: 'Activity',
    component: () => import('@/views/Activity/activity.vue')
  },
  {
    path: '/activity/detail/:id',
    name: 'ActivityDetail',
    component: () => import('@/views/Activity/activityDetail.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News/news.vue')
  },
  {
    path: '/news/detail/:id',
    name: 'NewsDetail',
    component: () => import('@/views/News/newsDetail.vue')
  },
  {
    path: '/courses',
    name: 'Courses',
    component: () => import('@/views/Courses/courses.vue')
  },
  {
    path: '/courses/detail/:id',
    name: 'CoursesDetail',
    component: () => import('@/views/Courses/coursesDetail.vue')
  },
  {
    path: '/expert',
    name: 'Expert',
    component: () => import('@/views/Expert/expert.vue')
  },
  {
    path: '/expert/detail/:id',
    name: 'ExpertDetail',
    component: () => import('@/views/Expert/expertDetail.vue')
  },
  {
    path: '/expert/interviews',
    name: 'Interviews',
    component: () => import('@/views/Expert/interviews.vue')
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/User/user.vue')
  },
  {
    path: '/search/:q',
    name: 'Search',
    component: () => import('@/views/Search/search.vue')
  },
  {
    path: '/apply',
    name: 'ApplyNow',
    component: () => import('@/views/Apply/index.vue'),
    meta: {
      title: '即刻申报'
    }
  }

]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  // routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }
    return { x: 0, y: 0 }
  },
 
    mode: 'hash',
    base: '',
    routes

})

export default router 